import { WidgetProps } from '@rjsf/utils';
import { Box, Typography } from '@mui/material';
import { Colors } from '../../../../ui/theme/colors';

export function StaticTextWidget(props: WidgetProps) {
  return (
    <Box>
      <Typography variant="caption" style={{ color: Colors.midGray }}>
        {props.label}
      </Typography>
      <Typography variant="body1">{props.value}</Typography>
    </Box>
  );
}
